import request from '@/utils/request'

// 设置教材版本
export const AddBookVerAPI = (data) => request.post('/resources/textbookversion/', data)

// 获取教材版本
export const GetHaveBookVerAPI = () => request.get('/resources/textbookversion/')
